<template>
    <div class="main-wrapper">
        <layout-header />

        <!-- Main Content -->
        <main class="flex-grow-1">
            <div class="container-fluid h-100">
                <div class="row h-100">

                    <!-- Listing Section (wider) -->
                    <div class="col-xl-7 d-flex flex-column border-end px-0">
                        <!-- Sticky Search Bar -->
                        <div class="sticky-top bg-white text-center px-3 d-flex align-items-center justify-content-center"
                            style="top: 0; height: 200px; padding-top: 90px;">
                            <form style="height: 46px;" @submit.prevent="updateQuery()"
                                class="d-inline-flex justify-content-between px-2 w-100 shadow-sm border rounded-pill bg-light">
                                <div class="px-1 px-lg-2 d-flex align-items-center h-100 w-100 text-sm">
                                    <span class="material-symbols-outlined text-lg text-muted">
                                        my_location
                                    </span>
                                    <v-select :options="governorates" v-model="filters.location" label="option"
                                        :reduce="option => option" placeholder="Où?" @update:modelValue="updateQuery()"
                                        class="custom-vs bg-transparent w-100 h-100 border-0 ml-1 text-sm">
                                    </v-select>
                                </div>
                                <!-- <div class="px-1 px-lg-2 d-flex align-items-center h-100 w-100">
                                    <span class="material-symbols-outlined text-lg text-muted ml-1">
                                        calendar_today
                                    </span>
                                    <input type="text" v-model="criteria.date" class="date bg-transparent w-100 h-100 border-0 px-1 ml-0 text-sm"
                                        role="button" readonly placeholder="Quand?" @change="updateQuery()"/>
                                </div> -->
                                <!-- <button type="submit" :disabled="!criteria.date || !filters.location"
                                    class="d-flex my-2 px-3 align-items-center justify-content-center rounded-pill bg-white border-0 shadow-sm">
                                    <span class="material-symbols-outlined text-lg text-muted mr-1">
                                        search
                                    </span>
                                    <p class="sr-only">Find establishments</p>
                                </button> -->
                            </form>

                            <span class="btn bg-light rounded-pill d-flex align-items-center ml-2 py-2 px-3 position-relative"
                                data-toggle="modal" data-target="#filtersModal" :class="{ 'border-dark text-dark': activeFiltersCount > 0, 'text-muted btn-light': activeFiltersCount === 0 }">
                                <span class="material-symbols-outlined text-lg py-1">tune</span>
                                <span class="d-none d-md-inline ml-1 text-sm">Filtres</span>
                                <span v-if="activeFiltersCount > 0"
                                    class="badge badge-dark text-white mr-2 mt-2 p-1 rounded-xl" 
                                    style="min-width: 20px; top:0; right:0; transform: translate(50%, -50%); position: absolute;">
                                    {{ activeFiltersCount }}
                                </span>
                            </span>
                        </div>

                        <div class="flex-grow-1 overflow-auto pb-2 pt-3" style="min-height: 70vh;">
                            <div class="row row-cols-1 mx-0 d-flex flex-wrap" v-if="establishments.length > 0">
                                <!-- Repeat 10+ cards -->
                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 mb-3 px-md-2 px-lg-3 px-2" v-for="(establishment, index) in establishments" :key="establishment.id"
                                    style="flex: 0 0 50%;">
                                    <div @mouseover="setHover(establishment.id, true)" @mouseleave="setHover(establishment.id, false)" class="h-100">
                                        <div class="border bg-white d-flex flex-column rounded-xl overflow-hidden h-100">
                                            <div class="overflow-hidden position-relative" style="height: 8rem;">
                                                <img :src="getFeaturedImage(establishment) || defaultFeaturedImage"
                                                    class="w-100 h-100 object-cover" loading="lazy">
                                                <img class="bg-white position-absolute inset-top-left rounded-lg overflow-hidden d-flex justify-content-center align-items-center p-1" 
                                                    :src="establishment.logo_url || defaultLogo" width="45px" height="45px">
                                            </div>
                                            <div class="d-flex flex-column justify-content-between flex-grow-1 mx-0 px-md-3 px-2" >
                                                <div class="d-flex justify-content-start pt-3">
                                                    <p class="overflow-hidden whitespace-nowrap">{{ establishment.business_name }}</p>
                                                </div>
                                                <div class="d-flex justify-content-start pb-1">
                                                    <p class="text-xs text-muted overflow-hidden whitespace-nowrap">{{ establishment.delegation }}</p>
                                                </div>
                                                <div class="d-flex justify-content-start align-items-center text-xs text-muted pb-1">
                                                    <span class="material-symbols-outlined mr-1">stadium</span>
                                                    <span class="mr-2">{{ establishment.facilities.length }}</span>
                                                    <span class="material-symbols-outlined mx-1">payments</span>
                                                    <span v-if="getPricesRange(establishment).length === 1">{{ getPricesRange(establishment)[0] }}<sup>DT</sup></span>
                                                    <span v-else-if="getPricesRange(establishment).length > 1">
                                                        {{ Math.min(...getPricesRange(establishment)) }}<sup>DT</sup> - {{ Math.max(...getPricesRange(establishment)) }}<sup>DT</sup>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center pb-3">
                                                    <div class="d-flex justify-content-start">
                                                        <span v-for="n in 5" :key="n"
                                                            class="material-icons text-light text-md"
                                                            :class="{ 'text-primary': n <= establishment.rating }">
                                                            star
                                                        </span>
                                                    </div>
                                                    <a class="btn btn-primary rounded-pill text-xs text-dark p-1 ml-1" :href="`/partner/${establishment.id}-${generateSlug([establishment.business_name, establishment.delegation].join(' '))}`"> 
                                                        <b>Réserver</b>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="pt-3 text-center">
                                <span class="text-sm">Aucune correspondance précise</span>
                            </div>
                        </div>
                    </div>

                    <!-- Map Section (smaller) use teleport -->
                    <div class="col-xl-5 d-none d-xl-block p-0 pl-3" style="padding-top: 120px;">
                        <div class="sticky-top pb-4" style="top: 120px; height: calc(100vh - 120px);">
                            <div id="map" class="rounded-xl w-100 h-100 bg-light overflow-hidden">
                                <GoogleMap v-if="!isMobile" class="w-100 h-100" :center="mapCenter" :zoom="9"
                                    :options="{mapTypeId: 'hybrid'}">
                                    <template v-slot="{ map }">
                                        <!-- store map once -->
                                        <div v-if="setMap(map)"></div>

                                        <Marker v-for="(marker, index) in markers"
                                            :key="index" :options="{
                                                title: marker.title,
                                                position: marker.position,
                                                icon: {
                                                    url: marker.hover || selectedMarker === marker ? marker.hoverIcon : marker.icon,
                                                    scaledSize: { width: 26, height: 26 }
                                                },
                                                zIndex: marker.hover || selectedMarker === marker ? 1000 : 1
                                            }" @click="selectedMarker = marker">
                                        </Marker>
                                        <InfoWindow v-if="selectedMarker" :options="{ position: selectedMarker.position,pixelOffset: { width: 0, height: -28 } }" @closeclick="selectedMarker = null">
                                            <div>
                                                <!-- Header -->
                                                <div class="info-header">
                                                    <a :href="'/partner/'+selectedMarker.establishment.id" target="_blank">
                                                        {{ selectedMarker.establishment.business_name }}
                                                    </a>
                                                </div>

                                                <!-- Body -->
                                                <div class="info-body">
                                                    <span>{{ selectedMarker.establishment.address }}</span><br>
                                                    <span>{{ selectedMarker.establishment.delegation }}</span><br>
                                                </div>
                                            </div>
                                        </InfoWindow>
                                    </template>
                                </GoogleMap>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="establishments.length > 0" class="d-block text-center d-xl-none position-sticky" style="z-index: 1000;" :style="{ bottom: currentUser.role == 'player' ? '70px' : 0 }">
                <span class="btn btn-sm btn-primary text-xs text-dark mb-3 rounded-pill" @click="openMap()">
                    Afficher dans Maps
                </span>
            </div>

            <div :class="{'d-none': !showMap}" class="position-fixed w-100 h-100 bg-white" style="top: 86px; left: 0; z-index: 1100;">
                <!-- Header -->
                <div class="d-flex align-items-center border-bottom p-3 pt-1">
                    <button class="btn btn-outline-secondary py-0 pb-1 px-2 mr-3 text-sm" @click="closeMap()">Retour</button>=
                </div>
                <!-- Map -->
                <div style="height: calc(100% - 120px);">
                    <div id="mobile-map" class="w-100 h-100">
                        <GoogleMap v-if="isMobile" class="w-100 h-100 overflow-hidden" :center="mapCenter" :zoom="9"
                            :options="{mapTypeId: 'hybrid'}">
                            <template v-slot="{ map }">
                                <!-- store map once -->
                                <div v-if="setMap(map)"></div>

                                <Marker v-for="(marker, index) in markers"
                                    :key="index" :options="{
                                        title: marker.title,
                                        position: marker.position,
                                        icon: {
                                            url: marker.hover || selectedMarker === marker ? marker.hoverIcon : marker.icon,
                                            scaledSize: { width: 26, height: 26 }
                                        },
                                        zIndex: marker.hover || selectedMarker === marker ? 1000 : 1
                                    }" @click="selectedMarker = marker">
                                </Marker>
                                <InfoWindow v-if="selectedMarker" :options="{ position: selectedMarker.position,pixelOffset: { width: 0, height: -28 } }" @closeclick="selectedMarker = null">
                                    <div>
                                        <!-- Header -->
                                        <div class="info-header">
                                            <a :href="'/partner/'+selectedMarker.establishment.id" target="_blank">
                                                {{ selectedMarker.establishment.business_name }}
                                            </a>
                                        </div>

                                        <!-- Body -->
                                        <div class="info-body">
                                            <span>{{ selectedMarker.establishment.address }}</span><br>
                                            <span>{{ selectedMarker.establishment.delegation }}</span><br>
                                        </div>
                                    </div>
                                </InfoWindow>
                            </template>
                        </GoogleMap>
                    </div>
                </div>
            </div>
        </main>

        <layout-footer />
    </div>

    <div class="modal fade" id="filtersModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header align-items-center">
                    <h5 class="modal-title">Filtres de recherche</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                </div>
                <div class="modal-body mb-4" style="min-height: 30vh;">
                    <div id="filters">
                        <div class="form-group card-label h-100 mb-3">
                            <label class="bg-light">Date</label>
                            <input type="text" v-model="criteria.date" class="date bg-transparent w-100 h-100 border-0 px-1 ml-0 text-sm"
                                role="button" readonly placeholder="Quand?"/>
                        </div>
                        <div class="form-group card-label h-100 mb-3">
                            <label class="bg-light">Horaire Préféré</label>
                            <div class="row mt-2">
                                <div class="col-6 col-lg-3">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="time_range1" v-model="criteria.time_range" value="00:00-06:00" name="time_range" class="custom-control-input">
                                        <label class="custom-control-label" for="time_range1">00:00-06:00</label>
                                    </div>
                                </div>
                                <div class="col-6 col-lg-3">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="time_range2" v-model="criteria.time_range" value="06:00-12:00" name="time_range" class="custom-control-input">
                                        <label class="custom-control-label" for="time_range2">06:00-12:00</label>
                                    </div>
                                </div>
                                <div class="col-6 col-lg-3">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="time_range3" v-model="criteria.time_range" value="12:00-17:00" name="time_range" class="custom-control-input">
                                        <label class="custom-control-label" for="time_range3">12:00-17:00</label>
                                    </div>
                                </div>
                                <div class="col-6 col-lg-3">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="time_range4" v-model="criteria.time_range" value="17:00-23:59" name="time_range" class="custom-control-input">
                                        <label class="custom-control-label" for="time_range4">17:00-23:59</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group card-label h-100 mb-3">
                            <label class="bg-light">Délégation</label>
                            <v-select :options="filteredDelegations" v-model="criteria.delegations" label="option" clearable multiple :reduce="option => option" class="custom-vs input w-auto">
                                <template #option="{ option }">
                                    <span><b>{{ option.split(', ')[0]}}</b>, {{ option.split(', ')[1] }}</span>
                                </template>
                            </v-select>
                        </div>
                        <!-- <div class="form-row align-items-center">
                            <div class="col-6">
                                <div class="form-group card-label h-100 mb-3">
                                    <label class="bg-light">Heure Min</label>
                                    <input type="text" class="form-control" placeholder="HH:mm" pattern="^([01]\d|2[0-3]):([0-5]\d)$"/>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group card-label h-100 mb-3">
                                    <label class="bg-light">Heure Max</label>
                                    <input type="text" class="form-control" placeholder="HH:mm" pattern="^([01]\d|2[0-3]):([0-5]\d)$"/>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal" @click="resetFilters()">Réinitialiser</button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" @click="applyFilters()">Appliquer</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.main-wrapper .material-icons, .main-wrapper .material-symbols-outlined {
    font-size: 1.1rem;
}
</style>
<style>
/* Target the InfoWindow content wrapper */
.gm-style-iw:has(.info-header) {
  /* font-family: "Roboto", Arial, sans-serif; */
  max-width: 250px !important;
  min-width: 180px !important;
  padding: 0 !important;
}
/* Header row: title aligned left, close button stays right */
.gm-style-iw:has(.info-header) .gm-style-iw-chr {
    position: absolute;
    top: 0;
    right: 0;
}
.gm-style-iw:has(.info-header) .gm-style-iw-chr button {
    width: 36px !important;
    height: 36px !important;
}
.gm-style-iw:has(.info-header) .gm-style-iw-chr button span {
    margin: auto !important;
    width: 20px !important;
    height: 20px !important;
}

/* Custom header bar */
.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  margin: 0;
  padding: 10px;
  padding-right: 36px;
  /* border-bottom: 1px solid #ddd; */
}

/* Body content */
.info-body {
  padding: 4px 10px 10px;
  font-size: 13px;
  color: #555;
}
</style>
<script>
import { GoogleMap, Marker, InfoWindow } from 'vue3-google-map'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
// import generateSlug from '@/utils/slugify';
import defaultMarker from '@/assets/img/marker.png'
import defaultMarkerHover from '@/assets/img/marker-hover.png'
import defaultLogoPath from '@/assets/img/photo.png'
import defaultFeaturedImagePath from '@/assets/img/blog/blog-01.jpg'

export default {
    components: {
        vSelect,
        GoogleMap,
        Marker,
        InfoWindow
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        isMobile() {
            return window.innerWidth < 1200;
        },
        activeFiltersCount() {
            const keys = Object.keys(this.filters)
            let activeFilters = 0
            keys.forEach(key => {
                const filter = this.filters[key]
                if (!this.isEmpty(filter) && key in this.criteria) {
                    activeFilters++
                }
            })
            return activeFilters
        },
        filteredDelegations() {
            if (!this.filters.location || this.filters.location === '') {
                return this.delegations
            }
            return this.delegations.filter(delegation => {
                return delegation.includes(this.filters.location.toUpperCase())
            })
        }
    },
    watch: {
        // 1. Watch URL → update form + fetch
        '$route.query': {
            immediate: true,
            handler(query) {
                this.criteria.date = this.filters.date = query.date || null
                this.filters.location = query.location || ''
                if (!this.isEmpty(this.criteria.delegations)) {
                    this.filters.delegations = this.criteria.delegations = this.criteria.delegations.filter(d => d.includes(this.filters.location.toUpperCase()))
                }

                this.searchEstablishments()
            }
        },
        markers: {
            deep: true,
            immediate: true,
            handler() {
                this.$nextTick(() => {
                    this.centerMap()
                })
            }
        }
    },
    data() {
        return {
            filters: {
                date: null,
                location: '',
                delegations: [],
                time_range: []
            },
            criteria: {
                date: null,
                delegations: [],
                time_range: []
            },
            selectedMarker: null,
            showMap: false,
            mapInstance: null,
            defaultLogo: defaultLogoPath,
            defaultFeaturedImage: defaultFeaturedImagePath,
            governorates: [],
            delegations: [],
            facilities: [],
            establishments: [],
            mapCenter: { lat: 36.8065, lng: 10.1815 },
            markers: {}
        }
    },
    created() {
        const vm = this
        this.getGovernorates()
        this.getDelegations()
        this.searchEstablishments()
        $(document).ready(function() {
            $('.date').datepicker({
                dateFormat: 'd/m/yy',
                minDate: 0,
                maxDate: "+1M",
                onSelect: (dateText) => {
                    vm.criteria.date = dateText;
                }
            });
        })
    },
    methods: {
        openMap() {
            this.showMap = true

            this.$nextTick(() => {
                this.fitBounds()
            })
        },
        closeMap() {
            this.showMap = false
        },
        setMap(map) {
            if (!this.mapInstance) {
                this.mapInstance = map
                this.centerMap()
            }
            return true
        },
        centerMap() {
            this.fitBounds()
        },
        fitBounds() {
            if (!this.mapInstance || !this.markers) return
            this.mapInstance.addListener("click", () => { this.selectedMarker = null; });
            
            const markerList = Object.values(this.markers)
            if (markerList.length === 1) {
                this.mapInstance.setCenter(markerList[0].position)
                this.mapInstance.setZoom(15)
                return
            }

            const bounds = new google.maps.LatLngBounds()
            markerList.forEach(m =>
                bounds.extend({ lat: m.position.lat, lng: m.position.lng })
            )

            this.mapInstance.fitBounds(bounds, 50)
        },
        generateSlug(text) {
            if (!text) return '';

            return text
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/[\s_]+/g, '-')
                .replace(/-+/g, '-');
        },
        getGovernorates() {
            api.get('/public/governorates')
                .then(response => {
                    const result = response.data
                    this.governorates = result
                })
        },
        getDelegations() {
            api.get('/public/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        searchEstablishments() {
            api.post('/search/establishments', this.filters)
                .then(response => {
                    const result = response.data
                    this.establishments = result
                    this.markers = {}
                    this.establishments.forEach(establishment => {
                        // establishment.rating = Math.floor(Math.random() * 5) + 1
                        let rating_sum = 0
                        let rating_count = 0
                        establishment.facilities.forEach(facility => {
                            rating_count += facility.count_rating
                            rating_sum += (facility.count_rating * facility.average_rating)
                        })
                        establishment.rating = Math.round(rating_sum / rating_count)
                        this.markers[establishment.id] = {
                            establishment: establishment,
                            position: { lat: establishment.latitude, lng: establishment.longitude },
                            title: establishment.business_name,
                            icon: defaultMarker,
                            hoverIcon: defaultMarkerHover,
                            hover: false
                        }
                    })
                    this.$nextTick(() => {
                        this.centerMap()
                    })
                })
        },
        updateQuery() {
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    date: this.criteria.date || null,
                    location: this.filters.location || ''
                }
            })
        },
        applyFilters() {
            this.filters = {
                ...this.filters,
                ...this.criteria
            }
            this.updateQuery()
            this.searchEstablishments()
        },
        resetFilters() {
            this.criteria = {
                delegations: [],
                time_range: []
            }
            this.applyFilters()
        },
        getFeaturedImage(establishment) {
            if (establishment.facilities.length === 0) return null
            const featuredImage = establishment.facilities[0].images.filter(img => img.role === 'featured')
            if (featuredImage.length > 0) return featuredImage[0]['thumb_medium_url']
            return null
        },
        getPricesRange(establishment) {
            const pricesRange = establishment.facilities.map(f => f.price)
            const uniquepricesRangeSet = new Set(pricesRange)
            return [...uniquepricesRangeSet]
        },
        formatLabel(option) {
            if (!option || typeof option !== "string") return "";
            const [delegation, state] = option.split(", ");
            return '<b>' + delegation + '</b>, ' + state;
        },
        setHover(index, state) {
            this.markers[index].hover = state;
        },
        setRating(n, index) {
            this.establishments[index].rating = n;
        },
        isEmpty(obj) {
            return obj === '' || obj == [] || obj === null || obj === undefined || 
                (typeof obj === 'object' && Object.keys(obj).length === 0);
        },
    }
}
</script>
